<template>
  <v-dialog max-width="300px" v-model="dialogModel">
    <v-card>
      <v-card-title class="headline">
        <span>{{ $t('message.extendMembership') }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-layout row wrap justify-content-center>
            <v-flex>
              <v-select
                :label="$t('message.numberMonths')"
                data-vv-name="months"
                :error-messages="errors.collect('months')"
                :items="months"
                v-model="numberOfMonths"
                v-validate="'required'"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outline @click="onClose" color="error" small>{{ $t('message.close') }}</v-btn>
        <v-btn outline @click="onSave" color="primary" small>{{ $t('message.add') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "subscriptionManage",
  props: {
    dialog: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      numberOfMonths: undefined,
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      dialogModel: this.dialog
    };
  },
  methods: {
    onClose() {
      this.$emit("update:dialog", false);
      this.$validator.reset();
      this.$refs.form.reset();
    },
    async onSave() {
      try {
        const valid = await this.$validator.validateAll();
        if (valid) {
          this.$emit("on-save", this.numberOfMonths);
          this.$emit("update:dialog", false);
        }
      } catch (err) {
        console.error(err);
      }
    }
  },
  watch: {
    dialog(value) {
      this.dialogModel = value;
    },
    dialogModel(value) {
      this.$emit("update:dialog", value);
    }
  }
};
</script>

<style>
</style>
